const report = {
  reportleftcontainer: {
    display: "flex",
    gap: "20px",
  },
  tripbtn: {
    backgroundColor: "rgb(241,241,241)",
    color: "green",
    borderRadius: "25px",
    paddingLeft: "34px",
    paddingRight: "34px",
    fontSize: "1rem",
  },
  consingmentbtn: {
    backgroundColor: "rgb(241,241,241)",
    color: "green",
    borderRadius: "25px",
    paddingLeft: "34px",
    paddingRight: "34px",
    fontSize: "1rem",
  },
  secondcontainer: {
    display: "flex",
    justifyContent: "",
  },
  firstcontan: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    marginTop: "18px",
  },
  overview: {
    flexgrow: "1",
  },
  controls: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
  },
  subcontainer: {
    marginLeft: "10px",
  },
  custmbtn: {
    padding: "10px",
    paddingLeft: "22px",
    paddingRight: "26px",
    borderRadius: "25px",
    border: "1px solid rgb(237,237,241)",
    textAlign: "center",
  },
  filterbtn: {
    width: "45px",
    height: "42px",
    borderRadius: "50%",
    border: "1px solid rgb(237,237,241) ",
    backgroundColor: "rgb(235,247,237)",
  },
  exportbtn: {
    width: "45px",
    height: "42px",
    borderRadius: "50%",
    border: "1px solid rgb(237,237,241) ",
    backgroundColor: "rgb(235,247,237)",
  },
  numberbox: {
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    marginTop: "35px",
    backgroundColor: "rgb(244,244,244)",
    borderRadius: "15px",
  },
  box1: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    // padding: "12px",
    flex: "1",
    position: "relative",
  },
  triphead:{
    marginTop:"27px",
    backgroundColor:"RED"

  },
  verticalLine: {
    position: "absolute",
    right: "0",
    top: "25%",
    height: "50%",
    width: "1px",
    backgroundColor: "gray",
  },
  lastBox: {
    borderRight: "none",
  },
  charts: {
    display: "flex",
    justifyContent: "center",
  },

  contchart: {
    display: "flex",
    flexDirection: "column",
    alignItems: "",
    border: "1px solid rgb(244,244,244)",
    width: "400px",
    height: "250px",
    marginTop: "20px",
    padding: "10px",
  },
  label: {
    display: "flex",
    justifyContent: "flex-start",
    marginBottom: "10px",
  },
  charts: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "20px",
    flexWrap: "wrap",
  },
  contchart: {
    flex: "1 1 45%",
    minWidth: "300px",
  },
  firstbox: {
    flex: "1 1 45%",
    minWidth: "300px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  label: {
    fontSize: "18px",
    marginBottom: "5px",
  },
  donut: {
    width: "100%",
    maxWidth: "300px",
    marginBottom: "10px",
  },
  circleContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "20px",
    marginTop: "20px",
  },
  circleRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    maxWidth: "400px",
    width: "100%",
    maxWidth: "400px",
    marginTop: "-10px",
  },
  creatingc: {
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    backgroundColor: "rgb(13,178,24)",
    marginRight: "10px",
  },
  newcolor: {
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    backgroundColor: "rgb(190,0,104)",
    marginLeft: "10px",
    marginRight: "10px",
  },
  nameText: {
    fontSize: "16px",
    color: "#333",
  },
  table: {
    marginTop: "40px",
  },
  reportleftcontainer: {
    display: "flex",
    gap: "20px",
  },
  tripbtn: {
    backgroundColor: "rgb(241,241,241)",
    color: "green",
    borderRadius: "25px",
    paddingLeft: "34px",
    paddingRight: "34px",
    fontSize: "1rem",
  },
  consingmentbtn: {
    backgroundColor: "rgb(241,241,241)",
    color: "green",
    borderRadius: "25px",
    paddingLeft: "34px",
    paddingRight: "34px",
    fontSize: "1rem",
  },
  secondcontainer: {
    display: "flex",
    justifyContent: "",
  },
  firstcontan: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    marginTop: "18px",
  },
  overview: {
    flexgrow: "1",
  },
  controls: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
  },
  subcontainer: {
    marginLeft: "10px",
  },
  custmbtn: {
    padding: "10px",
    paddingLeft: "22px",
    paddingRight: "26px",
    borderRadius: "25px",
    border: "1px solid rgb(237,237,241)",
    textAlign: "center",
  },
  filterbtn: {
    width: "45px",
    height: "42px",
    borderRadius: "50%",
    border: "1px solid rgb(237,237,241) ",
    backgroundColor: "rgb(235,247,237)",
  },
  exportbtn: {
    width: "45px",
    height: "42px",
    borderRadius: "50%",
    border: "1px solid rgb(237,237,241) ",
    backgroundColor: "rgb(235,247,237)",
  },
  numberbox: {
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    marginTop: "35px",
    backgroundColor: "rgb(244,244,244)",
    borderRadius: "15px",
  },
  box1: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "12px",
    flex: "1",
    position: "relative",
  },
  donut: {
    width: "100%",
    maxWidth: "400px",
    height: "",
  },
  charts: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "20px",
    flexWrap: "wrap",
  },
  contchart: {
    flex: "1 1 45%",
    minWidth: "300px",
  },
  firstbox: {
    flex: "1 1 45%",
    minWidth: "300px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    border: "1px solid rgb(237,237,242)",
    borderRadius: "20px",
    marginTop: "22px",
  },

  label: {
    fontSize: "18px",
    marginBottom: "5px",
  },
  donut: {
    width: "100%",
    maxWidth: "300px",
    marginBottom: "10px",
  },
  circleContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "20px",
    marginTop: "20px",
  },
  circleRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    maxWidth: "400px",
    width: "100%",
    maxWidth: "400px",
    marginTop: "-10px",
  },
  creatingc: {
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    backgroundColor: "rgb(13,178,24)",
    marginRight: "10px",
  },
  newcolor: {
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    backgroundColor: "rgb(190,0,104)",
    marginLeft: "10px",
    marginRight: "10px",
  },
  nameText: {
    fontSize: "16px",
    color: "#333",
  },
  table: {
    marginTop: "40px",
  },
  table: {
    marginTop: "35px",
  },
  //
  reportleftcontainer: {
    display: "flex",
    gap: "20px",
  },
  tripbtn: {
    backgroundColor: "rgb(241,241,241)",
    color: "green",
    borderRadius: "25px",
    paddingLeft: "34px",
    paddingRight: "34px",
    fontSize: "1rem",
  },
  consingmentbtn: {
    backgroundColor: "rgb(241,241,241)",
    color: "green",
    borderRadius: "25px",
    paddingLeft: "34px",
    paddingRight: "34px",
    fontSize: "1rem",
  },
  secondcontainer: {
    display: "flex",
    justifyContent: "",
  },
  firstcontan: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    marginTop: "18px",
  },
  overview: {
    flexgrow: "1",
  },
  controls: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
  },
  subcontainer: {
    marginLeft: "10px",
  },
  custmbtn: {
    padding: "10px",
    paddingLeft: "22px",
    paddingRight: "26px",
    borderRadius: "25px",
    border: "1px solid rgb(237,237,241)",
    textAlign: "center",
  },
  filterbtn: {
    width: "45px",
    height: "42px",
    borderRadius: "50%",
    border: "1px solid rgb(237,237,241) ",
    backgroundColor: "rgb(235,247,237)",
  },
  exportbtn: {
    width: "45px",
    height: "42px",
    borderRadius: "50%",
    border: "1px solid rgb(237,237,241) ",
    backgroundColor: "rgb(235,247,237)",
  },
  numberbox: {
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    marginTop: "35px",
    backgroundColor: "rgb(244,244,244)",
    borderRadius: "15px",
  },
  box1: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "12px",
    flex: "1",
    position: "relative",
  },

  charts: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "20px",
    flexWrap: "wrap",
  },
  contchart: {
    flex: "1 1 45%",
    minWidth: "300px",
  },
  firstbox: {
    flex: "1 1 45%",
    minWidth: "300px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    border: "1px solid rgb(237,237,242)",
    borderRadius: "20px",
    marginTop: "22px",
  },

  label: {
    fontSize: "18px",
    marginBottom: "5px",
  },
  donut: {
    width: "100%",
    maxWidth: "300px",
    marginBottom: "10px",
  },
  circleContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "20px",
    marginTop: "20px",
  },
  circleRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    maxWidth: "400px",
    width: "100%",
    maxWidth: "400px",
    marginTop: "-10px",
  },
  creatingc: {
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    backgroundColor: "rgb(13,178,24)",
    marginRight: "10px",
  },
  newcolor: {
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    backgroundColor: "rgb(190,0,104)",
    marginLeft: "10px",
    marginRight: "10px",
  },
  nameText: {
    fontSize: "16px",
    color: "#333",
  },
  table: {
    marginTop: "40px",
  },
  table: {
    marginTop: "35px",
  },
  charthalf: {
    border: "1px solid  lightgray",
    marginTop: "20px",
    borderRadius: "16px",
  },
  loadingtimechart: {
    marginTop: "28px",
    borderRadius: "16px",
    border: "1px solid  lightgray",
  },
  consingmentstatus: {
    padding:"20px",
    marginLeft: "20px",
  },
  loadingtime: {
    padding:"20px",
    marginLeft: "20px",
  },
  // consingmentstatus: {
  //   marginLeft: "20px",
  // },
  // loadingtime: {
  //   marginLeft: "20px",
  // },
  popup: {
    display: "flex",
    justifyContent: "center",
  },
  containbox: {
    display: "flex",
    justifyContent: "flex-start",
  },
  dividingbox: {
    display: "flex",
    justifyContent: "flex-start",
    gap: "20px",
    flexWrap: "wrap",
    width: "100%",
  },
  vehicle: {
    flexBasis: "22%",
    width: "100%",
  },
  select: {
    width: "100%",
    height: "2.5em",
    fontSize: "10px",
    padding: "13px",
    borderRadius: "15px",
    border: "1px solid #5F6D8C",
  },
  fourresult: {
    fontSize: "26px",
    color: "rgb(44,150,61)",
  },
  clearall: {
    backgroundColor: "rgb(44,150,61)",
    color: "white",
    paddingLeft: "24px",
    paddingRight: "24px",
    paddingTop: "14px",
    paddingBottom: "14px",
    borderRadius: "25px",
    border: "none",
  },
  able: {
    justifyContent: "center",
    display: "flex",
    color: "#5F6D8C",
  },
};

export default report;
